/**
 * Объект частично совместим с объектом конфига роутера, но в данный момент **не поддерживаются вложенные пути**
 */
export const loansRoutes = [
    {
        name: 'loans',
        path: '/loans',
        component: () => import(/* webpackChunkName: "loans" */ '/local/templates/redesign/src/pages/loans/index.vue'),
    },
    {
        name: 'loans-credit',
        path: '/loans/credit',
        component: () => import(/* webpackChunkName: "loans-credit" */ '/local/templates/redesign/src/pages/loans/credit.vue'),
    },
    {
        name: 'loans-refin',
        path: '/loans/refin',
        component: () => import(/* webpackChunkName: "loans-refin" */ '/local/templates/redesign/src/pages/loans/refin.vue'),
    },
    {
        name: 'loans-it',
        path: '/loans/it/',
        component: () => import(/* webpackChunkName: "loans-it" */ '/local/templates/redesign/src/pages/loans/it.vue'),
    },
    {
        name: 'loans-plastic',
        path: '/loans/plastic/',
        component: () => import(/* webpackChunkName: "loans-plastic" */ '/local/templates/redesign/src/pages/loans/plastic.vue'),
    },
    {
        name: 'loans-pension',
        path: '/loans/pension/',
        component: () => import(/* webpackChunkName: "loans-pension" */ '/local/templates/redesign/src/pages/loans/loansPensionPage.vue'),
    },
    {
        name: 'loans-holidays',
        path: '/loans/holidays/(.*)',
        component: () => import(/* webpackChunkName: "loans-holidays" */ '/local/templates/redesign/src/pages/loans/holidays.vue'),
    },
    {
        name: 'loans',
        path: '/loans/(.*)',
        component: () => import(/* webpackChunkName: "loans-products" */ '/local/templates/redesign/src/pages/loans/products.vue'),
    }
];
